<template>
  <div class="knowledgeManage">
    <div style="width: 300px;border-right: 1px solid #eaeaea">
      <div style="width: 100%;border: solid 1px #eaeaea;display: flex;flex-wrap: nowrap">
        <div v-for="item in folderButton" :key="item.id" class="folderButton">
          <FrameButton :key="item.id" :button="item" :parentData="currentCatalog"></FrameButton>
        </div>
      </div>
      <el-input v-model="searchCatalogInput" placeholder="搜索目录" @change="getCatalogList"></el-input>
      <div style="overflow-y: auto;height: calc(100% - 66px)" class="scroller">
        <div class="column" v-for="item in catalogList" :key="item.id">
          <el-checkbox v-model="item.checked" style="width: 100%" @change="selectCatalog()">
            <div style="display: flex;flex-wrap: nowrap">
              <div style="width: 210px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{item.name}}</div>
              <div style="width: 41px;color: #a6a6a6;font-size: 10px;text-align: right">{{item.knowledge_cnt}}</div>
            </div>
          </el-checkbox>
        </div>
      </div>
    </div>
    <div style="width: calc(100% - 250px)">
      <div class="contentHeader">
        <div class="searchBox">
          <div class="search">
            <el-input v-model="searchData.searchInput" size="small" placeholder="请输入问题现象或描述您的问题" class="searchInput small"></el-input>
            <el-button type="primary" size="small" class="searchButton" @click="searchKnowledge"><i class="fa fa-search large"></i></el-button>
          </div>
        </div>
        <div class="headerMenu">
          <el-date-picker v-model="searchData.dateRange" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="YYYY-MM-DD" @change="searchKnowledge"></el-date-picker>
          <el-checkbox-group v-model="searchData.searchBoxGroup" style="margin: 0 20px" max="1" @change="searchKnowledge">
            <el-checkbox-button v-for="item in checkBoxList" :label="item.label" :key="item.value" :value="item.value">{{ item.label }}</el-checkbox-button>
          </el-checkbox-group>
          <el-popover placement="bottom" :width="380" trigger="click">
            <template #reference>
              <el-button type="primary">
                <i class="fa fa-th" aria-hidden="true" style="color: #FFFFFF;font-size: 20px"></i>
              </el-button>
            </template>
            <h2>布局切换</h2>
            <div class="layout-box">
              <div class="layout-button" @click="setLayout(1)">
                <div v-for="i in 3" :key="i" style="width: 90px;height: 10px;background-color: #D3D3D3;margin: 5px 0"></div>
              </div>
              <div class="layout-button" @click="setLayout(2)">
                <div style="display: flex;flex-wrap: nowrap;margin: 5px 0" v-for="i in 3" :key="i">
                  <div style="width: 43px;height: 10px;background-color: #D3D3D3;margin-right: 4px"></div>
                  <div style="width: 43px;height: 10px;background-color: #D3D3D3;"></div>
                </div>
              </div>
              <div class="layout-button" @click="setLayout(3)">
                <div style="display: flex;flex-wrap: nowrap;margin: 5px 0" v-for="i in 3" :key="i">
                  <div style="width: 28px;height: 10px;background-color: #D3D3D3;margin-right: 3px"></div>
                  <div style="width: 28px;height: 10px;background-color: #D3D3D3;margin-right: 3px"></div>
                  <div style="width: 28px;height: 10px;background-color: #D3D3D3;"></div>
                </div>
              </div>
            </div>
          </el-popover>
          <FrameButton :key="addButton.id" :button="addButton"></FrameButton>
        </div>
      </div>
      <div class="card-box" v-infinite-scroll="loadKnowledgePage" :infinite-scroll-distance="50" v-if="knowledgeList.length > 0">
        <div class="rightContent">
          <div class="ltr" v-for="item in knowledgeList" :key="item.id" :style="'width: ' + layoutWidth + '%'">
            <div class="card" @click="openInfoPage(item)">
              <div class="card-box-header">
                <i class="fa fa-newspaper-o" aria-hidden="true" style="color: #0a84ff;margin-right: 5px"></i>{{item.catalog_name}}
              </div>
              <div style="display: flex; align-items: center; width: 100%;">
                <el-image v-if="rowSize !== 3 && item.catalog_icon !== undefined" style="width: 249px; height: 140px; flex-shrink: 0;" :src="item.catalog_icon"></el-image>
                <div style="flex-grow: 1; margin-left: 16px;">
                  <div class="card-content-container">
                    <h3>{{ item.question }}</h3>
                  </div>
                  <div style="height: 82px;">
                    <div class="card-description">{{item.answer}}</div>
                  </div>
                </div>
              </div>
              <div style="height: 18px;font-size: 12px;color: #888;display: flex;justify-content: right">
                <div style="display: flex;flex-wrap: nowrap;line-height: 18px;margin-right: 10px">
                  <el-icon :size="18" style="margin-right: 3px"><ElIconView/></el-icon>
                  <div style="margin-top: 1px">{{ item.view_cnt }}</div>
                </div>
                <div style="display: flex;flex-wrap: nowrap;line-height: 18px;margin-right: 10px">
                  <el-icon :size="18" style="margin-right: 3px"><ElIconStar/></el-icon>
                  <div style="margin-top: 1px">{{ item.collect_cnt }}</div>
                </div>
                <div style="line-height: 18px;margin-right: 10px;margin-top: 1px">
                  <i class="fa fa-thumbs-o-up" aria-hidden="true" style="font-size: 14px;margin-right: 3px"></i>{{ item.help_cnt }}
                </div>
                <div style="line-height: 18px;margin-right: 10px;margin-top: 1px">
                  <i class="fa fa-thumbs-o-down" aria-hidden="true" style="font-size: 14px;margin-right: 3px"></i>{{ item.no_help_cnt }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-empty class="empty-box" description="没有找到相关内容" v-else></el-empty>
    </div>
  </div>
</template>

<script>

export default {
  name: "KnowledgeManage",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  provide() {
    return {
      $fn: {
        reloadTreeData: () => {
          // 刷新目录
          this.currentCatalog = {}
          this.getCatalogList();
        }
      }
    }
  },
  data() {
    return {
      rowSize: 2,
      layoutWidth: 50.0,
      searchCatalogInput: '',
      addButton:{
        "id": "prj_knowledge_add",
        "component": "button",
        "type": "primary",
        "label":"添加问题",
        "style": "font-size: 14px",
        "click": "jsOpenWindow",
        "click_success": ["jsRefreshForm"],
        "window": {"component": "frame/FrameForm", "type": "prj_knowledge_add", "title": "添加问题", "width": 1100, "height": 600}
      },
      checkBoxList: [
        {
          label: '我的收藏',
          value: 'myCollection'
        },
        {
          label: '我的提交',
          value: 'mySubmit'
        },
      ],
      currentCatalog: {},
      catalogList: [],
      folderButton: [
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-folder-add",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenWindow",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "prj_knowledge_catalog_add", "title": "添加目录", "width": 500, "height": 350}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-edit",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenWindow",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "prj_knowledge_catalog_edit", "title": "修改目录", "width": 500, "height": 400}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-delete",
          "icon_only": true,
          "style": "font-size: 24px",
          "click": "jsOpenWindow",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "prj_knowledge_catalog_del", "title": "删除目录", "width": 600, "height": 350}
        }
      ],
      searchData: {searchInput: '',pageSize: 18, pageNum: 1,dateRange: '',searchBoxGroup:[]},
      knowledgeList: [],
      maxPages: 1
    }
  },
  methods: {
    setLayout(size){
      this.layoutWidth = 100/size
      this.rowSize = size
    },
    selectCatalog(){
      for (let i = 0; i < this.catalogList.length; i++){
        if (this.catalogList[i].checked){
          this.currentCatalog = this.catalogList[i]
        }
      }
      this.searchKnowledge()
    },
    openInfoPage(item){
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "project/KnowledgeInfo";
      windowObj.name = "问题详情";
      windowObj.parentData = item;
      windowObj.height = 600 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1100 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.no_min = false
      windowObj.max = false

      this.$store.dispatch('core/openWindow', windowObj)
    },
    async searchKnowledge(){
      let catalogIds = []
      for (let i = 0; i < this.catalogList.length; i++){
        if (this.catalogList[i].checked){
          catalogIds.push(this.catalogList[i].id)
        }
      }
      this.searchData.pageNum = 1
      this.searchData.catalogIds = catalogIds
      let data = await this.$http('prjKnowledgeService.searchKnowledge', this.searchData)
      this.knowledgeList = data.records
      this.maxPages = data.pages
    },
    async loadKnowledgePage () {
      if (this.searchData.pageNum >= this.maxPages){
        return
      }
      this.searchData.pageNum = this.searchData.pageNum + 1
      let data = await this.$http('prjKnowledgeService.searchKnowledge', this.searchData)
      this.knowledgeList.push(...data.records);
    },
    async getCatalogList() {
      this.catalogList = await this.$http('prjKnowledgeCatalogService.getCatalogList',{searchText:this.searchCatalogInput})
    }
  },
  created() {
    this.getCatalogList()
    this.searchKnowledge()
  }
}
</script>
<style lang="less" scoped>
@import '@/global.less';
.layout-button:hover{
  background-color: #eaeaea;
}
.layout-button{
  width: 100px;
  height: 50px;
  border: 1px solid #D3D3D3;
  border-radius: 5px;
  padding: 0 5px
}
.layout-box{
  display: flex;
  flex-wrap: nowrap
}
.layout-box > div{
  margin: 10px;
}
.column{
  height: 30px;
  line-height: 30px;
  padding: 0 10px
}
.column:hover{
  background-color: #e0e0e0;
}
.scroller::-webkit-scrollbar {
  width: 3px;
}
.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}
.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}
.searchInput ::v-deep(.el-input__wrapper) {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
}
.searchInput ::v-deep(.el-input__inner) {
  font-size: 20px !important;
}
.searchButton {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
  padding: 0 8px;
  line-height: 50px;
  height: 50px;
  width: 80px;
  font-size: 20px;
  font-weight: 400
}
.search{
  border-radius: 6px;
  min-width: 480px;
  margin-top: 10px;
  height: 50px;
  line-height: 50px;
  width: 80%;
  background-color: #FFFFFF;
  box-shadow: 0 2px 19px #1a61bc29;
  display: flex;
  justify-content: space-between;
}
.headerMenu{
  margin-top: 10px;
  height: 40px;
  padding: 0 30px;
  display: flex;
  flex-wrap: nowrap;
}
.headerMenu ::v-deep(.el-range-editor.el-input__wrapper){
  max-width: 250px !important;
}
.contentHeader{
  background: radial-gradient(circle, #E4EAFD, #F8FAFD);
  height: 110px;
}
.searchBox{
  display: flex;
  justify-content: center;
  text-align: center;
}
.empty-box{
  width: 100%;
  height: calc(100% - 110px);
  background: radial-gradient(circle, #E4EAFD, #F8FAFD);
}
.card-box {
  width: 100%;
  height: calc(100% - 110px);
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  background-color: white;
  overflow-y: auto;
  background: radial-gradient(circle, #E4EAFD, #F8FAFD);
}
.rightContent{
  width: 100%;
  min-width: 600px;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
}
.ltr{
  height: 206px;
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 16px
}
.card{
  background-image: linear-gradient(180deg,#f6faff,#fff 19% 100%);
  box-shadow: 0 2px 19px #1a61bc29;
  border-radius: 12px;
  cursor: pointer;
  border: 0!important;
  height: 100%;
  padding: 16px;
}
.card:hover{
  box-shadow: 0 2px 19px #C0C0C0;
}
.card-box-header{
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-content-container{
  height: 44px;
  margin: 5px 0;
}
.card-content-container h3{
  font-size: 14px;
  font-weight: 800;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
.card-description{
  font-weight: 400;
  font-size: 12px;
  color: #555;
  letter-spacing: 0;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.knowledgeManage{
  display: flex;
  flex-wrap: nowrap;
}
</style>
